import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import CollapsibleSection from '@v2/commons/components/ModalCollapsibleSection/ModalCollapsibleSection.component'
import { POLICIES } from '@v2/commons/config'
import ChatMessages from '@v2/domains/chat/components/chat.component'

const EscalationNotes = ({ chatId }: { chatId: string }) => {
  return (
    <CollapsibleSection header="Additional Notes">
      <ChatMessages chatId={chatId} />
    </CollapsibleSection>
  )
}
export default withErrorBoundaryAndPolicyCheck(
  EscalationNotes,
  POLICIES.isGetChatMessagesEnabled,
)
